import assets from "./assets";

export default {
    broadcaster: {
        register_to_become_a_broadcaster_left_area_title: "Time to go LIVE!",
        register_to_become_a_broadcaster_left_area_subtitle: "Congratulations on being ready to get going with your first LIVE broadcast! Before you can start we need some more info about you and your channel",
        register_to_become_a_broadcaster_title: "Register to become a broadcaster",
        register_to_become_a_broadcaster_subtitle: "We will only be able to make payments to the person named here so using your real name is a good idea ;)"
    },
    valid: {
        password: "Password must be at least 6 characters",
        confirmPassword: "Password and conform Password are not same."
    },
    validation: {
        password_minimum_length: "Please enter valid password with at least 6 characters",
        password_maximum_length: "Password cannot exceeds 100 characters"
    },
    yoti: {
        after_create_profile: "Thanks for requesting to become a broadcaster. For identification purpose, you will have to verify your account by providing respective documents. Do you want to proceed?",
        unverified_access: "Your account is in pending state, to verify your account you have to verify your identify by providing respective documents. Do you want to proceed?"
    },
    user: {
        follow_unfollow:{
            unfollow: {
                title:"Unfollow broadcaster",
                description:"Are you sure you want to unfollow broadcaster?"
            },
        },
        fav_unfav:{
            unfav: {
                title:"Unfavourite broadcaster",
                description:"Are you sure you want to Unfavourite broadcaster?"
            },
        }
    },
    clipstore: {
        broadcaster: {
            delete_gallery: {
                title: "Delete Gallery",
                description: "Are you sure you want to delete this gallery?"
            },
            delete_videos: {
                title: "Delete Video",
                description: "Are you sure you want to delete this video?"
            },
            delete_pictures: {
                title: "Delete Picture",
                description: "Are you sure you want to delete this picture?"
            },
            upload_failed:{
                title:"Uploading Failed",
                description:"Would you like to retry or delete the video?"
            },
            upload_success:{
                title:"Successful",
                description:"Your video has been uploaded successfully"
            },
            cancel_subscription:{
                title:"Cancel subscription",
                description:"Are you sure you want to cancel the subscription?"
            },
            unfollow:{
                title:"Unfollow broadcaster",
                description:"Are you sure you want to unfollow the broadcaster?"
            },
        }
    },
    messaging:{
        no_messages_found:{
            image:assets.messaging.no_message,
            title:'No messages found!',
            description:'You have no new messages to your chat inbox, Please connect with other users.\n',
            btnText:'NEW CHAT'
        },
        nothing_selected:{
            image:assets.messaging.messaging_no_selection,
            title:'Get in touch with the users!',
            description:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.\n',
            btnText:''
        },
        no_search_result:{
            image:assets.empty.no_result_for_search,
            title:'No results found!',
            description:"We couldn't find a match for your search. Please try another search",
            btnText:''
        },
        delete_message:{
            title:"Delete Message",
            description:"Are you sure you want to delete this message?"
        },
        archive_message:{
            title:"Archive Chat",
            description:"Are you sure you want to archive this chat? (NOTE: An archive chat be retrieved again by re-initiating the chat)"
        },
        block_message:{
            title:"Block User",
            description:"Are you sure you want to block this user?"
        },
    },
    comment:{
        delete: {
            title: "Delete Comment",
            description: "Are you sure you want to delete this comment?"
        },
    },
    reply:{
        delete: {
            title: "Delete Reply",
            description: "Are you sure you want to delete this reply?"
        },
    }
}